import {format} from 'date-fns';
import {timeago} from '../date/timeago';
import {t} from './getTranslations';
import {OnIssueVo} from './shared/api/nicolas/vo/enums/OnIssueVo.enum';
import {getDateDifference} from './shared/utils/getDateDifference';
import {getFormattedNumberWithSuffix} from './shared/utils/getFormattedNumberWithSuffix';
import {parseDate} from './shared/utils/parseDate';

export function getNormalListViewMetaList({
  viewCount,
  lastSlideAddedDt,
  lastReadDt,
  currentDate,
  onIssueVo,
  pubPeriod,
  needShowFullUpdatedDate,
  isAltText,
}: {
  viewCount?: number;
  lastSlideAddedDt?: string;
  lastReadDt?: string;
  currentDate?: Date;
  onIssueVo?: OnIssueVo;
  pubPeriod?: string;
  needShowFullUpdatedDate?: boolean;
  isAltText?: boolean;
}) {
  const resultArr = [];
  // 조회수
  if (viewCount !== undefined) {
    resultArr.push(
      isAltText
        ? t('common_accessibility_view_count', {
            values: {
              value: getFormattedNumberWithSuffix(viewCount),
            },
          })
        : getFormattedNumberWithSuffix(viewCount)
    );
  }
  // 업데이트 일시
  if (lastSlideAddedDt && currentDate) {
    const addedDate = parseDate(lastSlideAddedDt);
    const {days} = getDateDifference({
      dateLeft: currentDate,
      dateRight: addedDate,
    });

    if (days >= 7 || needShowFullUpdatedDate) {
      resultArr.push(
        t('common_accessibility_update_date', {
          values: {
            value: format(addedDate, t('date_formatter_short_year_dot')),
          },
        })
      );
    } else {
      if (days === 0) {
        resultArr.push(t('landing_series_update_today'));
      } else {
        resultArr.push(
          t('landing_series_update_before_day', {values: {value: days}})
        );
      }
    }
  }
  // 열람 일자
  if (lastReadDt !== undefined) {
    const lastReadDateText = isAltText
      ? t('common_accessibility_last_read_date', {
          values: {
            value: timeago({
              date: parseDate(lastReadDt),
            }),
          },
        })
      : timeago({
          date: parseDate(lastReadDt),
        });
    resultArr.push(lastReadDateText);
  }
  // 연재 상태
  if (onIssueVo !== undefined) {
    resultArr.push(
      onIssueVo === OnIssueVo.End
        ? t('landing_ongoing_tab_completed')
        : onIssueVo === OnIssueVo.Pause || onIssueVo === OnIssueVo.PauseLegacy
          ? t('common_content_rest')
          : `${pubPeriod ? pubPeriod + ' ' : ''}${t('library_content_ongoing')}`
    );
  }
  return resultArr;
}
